import { cn } from 'src/lib/utils';

import { Spinner } from '../ui/spinner';

interface PageLoaderProps extends React.ComponentProps<typeof Spinner> {
  isOverlay?: boolean;
  className?: string;
}

export const PageLoader = ({
  isOverlay,
  className,
  size,
  children,
}: React.PropsWithChildren<PageLoaderProps>) => {
  return (
    <div
      className={cn(
        'flex h-dvh w-full items-center justify-center gap-12',
        isOverlay && 'fixed inset-0 z-100 bg-white/50 backdrop-grayscale-50',
        className,
      )}
    >
      <Spinner size={size} />

      {children}
    </div>
  );
};
